import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import Dialog from '@material-ui/core/Dialog'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import cn from 'classnames'
import {
  setChartType,
  setShowChartModal,
  fetchWeatherData,
  fetchSensorsData,
} from 'reducers/slaMonitor/environment/reducer'
import {
  MODULE_A,
  MODULE_B,
  TYPE_SATURATION,
  TYPE_OXYGEN,
  TYPE_TEMPERATURE,
  TYPE_SPEED,
} from 'helpers/environmentMonitor'
import messages from 'components/Apps/SlaMonitor/translate'
import SaturationChart from './charts/SaturationChart'
import OxygenChart from './charts/OxygenChart'
import WaterTemperatureChart from './charts/WaterTemperatureChart'
import CurrentSpeedChart from './charts/CurrentSpeedChart'

class ChartModal extends Component {
  getComponent = type => {
    const components = {
      saturation: SaturationChart,
      oxygen: OxygenChart,
      temperature: WaterTemperatureChart,
      speed: CurrentSpeedChart,
    }

    return components.hasOwnProperty(type)
      ? components[type]
      : components.saturation
  }

  onCloseModal = () => {
    this.props.setShowChartModal(false)
  }

  onChartTypeClick = e => {
    const chartType = e.currentTarget.dataset.type
    this.props.setChartType(chartType)
  }

  render() {
    const {
      isShowChartModal,
      chartType,
      intl: { formatMessage },
    } = this.props
    const SensorChart = this.getComponent(chartType)

    return (
      <Dialog open={isShowChartModal} onClose={this.onCloseModal} maxWidth="xl">
        <div className="environment-chart-modal-header">
          <ButtonGroup className="button-group">
            <Button
              className={cn({
                active: chartType === TYPE_SATURATION,
              })}
              data-type="saturation"
              onClick={this.onChartTypeClick}>
              {formatMessage(messages.saturation)}
            </Button>
            <Button
              className={cn({
                active: chartType === TYPE_OXYGEN,
              })}
              data-type="oxygen"
              onClick={this.onChartTypeClick}>
              {formatMessage(messages.oxygen)}
            </Button>
            <Button
              className={cn({
                active: chartType === TYPE_TEMPERATURE,
              })}
              data-type="temperature"
              onClick={this.onChartTypeClick}>
              {formatMessage(messages.waterTemperature)}
            </Button>
            <Button
              className={cn({
                active: chartType === TYPE_SPEED,
              })}
              data-type="speed"
              onClick={this.onChartTypeClick}>
              {formatMessage(messages.current)}
            </Button>
          </ButtonGroup>

          <ButtonGroup className="button-group">
            <Button
              className="active"
              data-module={MODULE_A}
              onClick={this.onBtnModuleClick}>
              Module A
            </Button>
            <Button data-module={MODULE_B} onClick={this.onBtnModuleClick}>
              Module B
            </Button>
          </ButtonGroup>
        </div>
        <div className="environment-chart-modal-content">
          <SensorChart />
        </div>
      </Dialog>
    )
  }
}

export default connect(
  state => ({
    isShowChartModal: state.getIn(['environment', 'isShowChartModal']),
    chartType: state.getIn(['environment', 'chartType']),
  }),
  {
    setShowChartModal,
    setChartType,
    fetchWeatherData,
    fetchSensorsData,
  },
)(injectIntl(ChartModal))
